/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
import * as ApolloReactCommon from '@apollo/client';
import * as ApolloReactHooks from '@apollo/client';
const defaultOptions = {} as const;
export type ConfigurationCard_DisplayFragment = { __typename: 'Display', id: string, configurationSyncStatus?: Types.ConfigurationSyncStatus | null, configurationUpdatedAt?: string | null, host?: { __typename: 'Host', coupledState?: string | null } | null, configuration?: { __typename: 'ConfigurationModel', id: string, name: string } | null, groups: Array<{ __typename: 'Group', id: string, name: string }>, bookmarks: { __typename: 'Bookmarks', all: { __typename: 'AllBookmarksState', reported?: Array<string> | null } }, platform: { __typename: 'DisplayPlatform', name: string, version?: string | null, type: string }, appSubscriptions: Array<{ __typename: 'DisplayAppSubscription', id: string, name: string }> };

export type AssignConfigurationMutationVariables = Types.Exact<{
  input: Types.DisplayBulkAssignConfigurationsInput;
}>;


export type AssignConfigurationMutation = { __typename: 'Mutation', assignConfiguration: string };

export const ConfigurationCard_DisplayFragmentDoc = gql`
    fragment ConfigurationCard_display on Display {
  id
  host {
    coupledState
  }
  configuration {
    id
    name
  }
  groups {
    id
    name
  }
  bookmarks {
    all {
      reported
    }
  }
  platform {
    name
    version
    type
  }
  appSubscriptions {
    id
    name
  }
  configurationSyncStatus
  configurationUpdatedAt
}
    `;
export const AssignConfigurationDocument = gql`
    mutation assignConfiguration($input: DisplayBulkAssignConfigurationsInput!) {
  assignConfiguration(input: $input)
}
    `;
export type AssignConfigurationMutationFn = ApolloReactCommon.MutationFunction<AssignConfigurationMutation, AssignConfigurationMutationVariables>;

/**
 * __useAssignConfigurationMutation__
 *
 * To run a mutation, you first call `useAssignConfigurationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAssignConfigurationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [assignConfigurationMutation, { data, loading, error }] = useAssignConfigurationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAssignConfigurationMutation(baseOptions?: ApolloReactHooks.MutationHookOptions<AssignConfigurationMutation, AssignConfigurationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useMutation<AssignConfigurationMutation, AssignConfigurationMutationVariables>(AssignConfigurationDocument, options);
      }
export type AssignConfigurationMutationHookResult = ReturnType<typeof useAssignConfigurationMutation>;
export type AssignConfigurationMutationResult = ApolloReactCommon.MutationResult<AssignConfigurationMutation>;
export type AssignConfigurationMutationOptions = ApolloReactCommon.BaseMutationOptions<AssignConfigurationMutation, AssignConfigurationMutationVariables>;